import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  MailPlus,
  Users,
  MessagesSquare,
  Calendar1Icon,
  Settings,
  LogOut,
} from "lucide-react";
import { Menu } from "antd";
import { useEffect, useMemo, useState } from "react";
import { clearSession } from "../utils/authSession";

export default function FirmSidebar() {
  const location = useLocation();
  const path = location.pathname;
  const navigate = useNavigate();

  // Only one submenu group for firms: service requests
  const rootSubmenuKeys = useMemo(() => ["sr"], []);
  const [openKeys, setOpenKeys] = useState([]);

  const handleLogout = () => {
    clearSession();
    navigate("/login");
  };

  const getSelectedKey = () => {
    if (path.includes("/firm/dashboard")) return "dashboard";
    if (path.includes("/firm/requests")) return "requests";
    // if (path.includes("/firm/lawyers")) return "lawyers";
    if (path.includes("/firm/teams")) return "teams";
    if (path.includes("/firm/chats")) return "chats";
    if (path.includes("/firm/meetings")) return "meetings";
    if (path.includes("/firm/firmProfile")) return "settings";
    return "";
  };

  useEffect(() => {
    const keys = [];
    if (path.includes("/firm/requests")) keys.push("sr");
    setOpenKeys(keys);
  }, [path]);

  const onOpenChange = (keys) => {
    const latestOpenKey = keys.find((k) => !openKeys.includes(k));
    if (!latestOpenKey) return setOpenKeys(keys);
    if (rootSubmenuKeys.includes(latestOpenKey)) setOpenKeys([latestOpenKey]);
    else setOpenKeys(keys);
  };

  // Firm-only: requests under Service Requests
  const srChildren = [
    { key: "requests", label: <Link to="/firm/requests">Service Requests</Link> },
  ];

  // Firm-only items (no services, no firms, no content, no queries)
  const items = [
    {
      key: "dashboard",
      icon: <LayoutDashboard size={18} />,
      label: <Link to="/firm/dashboard">Dashboard</Link>,
    },
    {
      key: "sr",
      icon: <MailPlus size={18} />,
      label: "Service Requests",
      children: srChildren,
    },
    // {
    //   key: "lawyers",
    //   icon: <Users size={18} />,
    //   label: <Link to="/firm/lawyers">Lawyers</Link>,
    // },
    {
      key: "team",
      icon: <Users size={18} />,
      label: <Link to="/firm/teams">Teams</Link>,
    },
    {
      key: "chats",
      icon: <MessagesSquare size={18} />,
      label: <Link to="/firm/chats">Chats & Messages</Link>,
    },
    {
      key: "meetings",
      icon: <Calendar1Icon size={18} />,
      label: <Link to="/firm/meetings">Meetings</Link>,
    },
    {
      key: "settings",
      icon: <Settings size={18} />,
      label: <Link to="/firm/firmProfile">Profile</Link>,
    },
    {
      key: 'logout',
      label: (
        <button
          type="button"
          onClick={handleLogout}
          style={{
            font:25,
            color:'white',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            width: '100%',
            background: 'none',
            border: 'none',
            padding: 0,
            cursor: 'pointer',
          }}
        >
          <LogOut size={18} />
          <span>Logout</span>
        </button>
      ),
    },
  ];

  return (
    <aside className="admin-sidebar">
      <Menu
        mode="inline"
        theme="dark"
        className="sidebar-menu"
        selectedKeys={[getSelectedKey()]}
        openKeys={openKeys}
        onOpenChange={onOpenChange}
        items={items}
      />
    </aside>
  );
}
